import React from 'react'
import { Button, Modal, message } from 'antd'
import { ReloadOutlined, DeleteOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { ButtonGroup } from '../styles'

interface ActionButtonsProps {
  loading: boolean
  autoRefresh: boolean
  onRefresh: () => void
  onCleanupStuck: () => Promise<any>
  onClearConnections: () => Promise<any>
  onToggleAutoRefresh: () => void
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  loading,
  autoRefresh,
  onRefresh,
  onCleanupStuck,
  onClearConnections,
  onToggleAutoRefresh
}) => {
  const handleCleanup = () => {
    Modal.confirm({
      title: 'Очистить зависшие запросы?',
      content: 'Это удалит все запросы, которые выполняются дольше 2 минут',
      onOk: async () => {
        try {
          const result = await onCleanupStuck()
          message.success(`Очищено ${result.cleanedCount} запросов`)
          onRefresh()
        } catch (error) {
          message.error('Ошибка очистки')
        }
      }
    })
  }

  const handleClearConnections = () => {
    Modal.confirm({
      title: 'Сбросить все соединения?',
      content: 'Это может временно прервать отправку писем',
      onOk: async () => {
        try {
          const result = await onClearConnections()
          message.success(`Очищено ${result.clearedSmtp} SMTP и ${result.clearedImap} IMAP соединений`)
          onRefresh()
        } catch (error) {
          message.error('Ошибка сброса соединений')
        }
      }
    })
  }

  return (
    <ButtonGroup>
      <Button type="primary" icon={<ReloadOutlined />} onClick={onRefresh} loading={loading}>
        Обновить
      </Button>
      <Button icon={<DeleteOutlined />} onClick={handleCleanup}>
        Очистить зависшие
      </Button>
      <Button danger icon={<CloseCircleOutlined />} onClick={handleClearConnections}>
        Сбросить соединения
      </Button>
      <Button type={autoRefresh ? 'default' : 'dashed'} onClick={onToggleAutoRefresh}>
        {autoRefresh ? '⏸ Остановить автообновление' : '▶️ Включить автообновление'}
      </Button>
    </ButtonGroup>
  )
}

